

















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { CompanyEventBus, ADD_EDIT_COMPANY } from "../api/company.event";
import { ICompany } from "@/features/companies/api/company.interface";

@Component({
  name: "CompanyToolbar"
})
export default class CompanyToolbar extends Vue {
  add() {
    let c: ICompany = { id: -1, name: "", qbDesktopPath: "" };
    CompanyEventBus.$emit(ADD_EDIT_COMPANY, c);
  }
}
